module.exports = "::ng-deep .img-pin img, .img-pin video, .img-pin iframe, .img-pin audio {\n    max-width: 300px;\n    max-height: 300px;\n}"